import React from 'react';
import { Label } from '@/shared/ui/label';
import { Input } from '@/shared/ui/input';

interface DateInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const DateInput: React.FC<DateInputProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="drone-date">
        Date <span className="text-red-500">*</span>
      </Label>
      <Input
        id="drone-date"
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        required
      />
    </div>
  );
};

